// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimDetails-cls1_J8i","cls2":"ClaimDetails-cls2_hyv ClaimDetails-cls1_J8i"};